import type {
  ActionButton,
  ToastActionButton,
} from '@bizzdesign/shared/models';
import type { Observable } from 'rxjs';

export function getSearchHeaderAction(
  id: string,
  labelKey: string,
  icon: string,
  disabled$: Observable<boolean>,
  onClick: (event?: any) => void,
  tooltipKey$: Observable<string>,
): ActionButton {
  return {
    id: id,
    labelKey: labelKey,
    tScope: 'featureSearch',
    onClick: onClick,
    icon: icon,
    type: 'tertiary',
    group: 'neutral',
    size: 'small',
    disabled$: disabled$,
    tooltipKey$,
    tooltipPos: 'bottom',
  };
}

export function getPopulationToastAction(
  onClick: (event?: any) => void,
): ToastActionButton {
  return {
    labelKey: 'populationSavedToast.buttonLabel',
    tScope: 'featureSearch',
    onClick: onClick,
  };
}
